export const APP_ENV = process.env.REACT_APP_ENV

export const SERVICE_VERSION = process.env.REACT_APP_SERVICE_VERSION

export const GRAPHQL_PORT = process.env.GRAPHQL_PORT || 4000
export const IS_LOCAL = APP_ENV === 'local'
export const IS_PRODUCTION = APP_ENV === 'production'
export const IS_STAGING = APP_ENV === 'staging'
const IS_TEST = process.env.NODE_ENV === 'test'

if (!(IS_PRODUCTION || IS_TEST)) console.log(process.env)

export const ANALYTICS_CONFIG = {
  mixpanelAuthToken: process.env.REACT_APP_MIXPANEL_AUTH_TOKEN || 'dev-token',
  debugMode: !(IS_PRODUCTION || IS_TEST),
}

export const AUTH0 = {
  DOMAIN: process.env.REACT_APP_AUTH0_BASE_URL,
  CLIENT_ID: process.env.REACT_APP_AUTH0_TELEHEALTH_CLIENT_ID,
  AUDIENCE: process.env.REACT_APP_AUTH0_EMR_AUDIENCE,
}

export const LAUNCH_DARKLY = {
  CLIENT_ID: process.env.REACT_APP_LAUNCH_DARKLY_CLIENT_ID,
}

// TODO: simply env setup
export const APP_ENDPOINT =
  process.env.REACT_APP_URL_OVERRIDE ||
  (IS_LOCAL
    ? 'http://localhost:3002'
    : IS_PRODUCTION
    ? 'https://telehealth.truepill.com'
    : 'https://telehealth.falsepill.com')

export const GQL_SERVER_ENDPOINT =
  process.env.REACT_APP_BACKEND_URL_OVERRIDE ||
  (IS_LOCAL
    ? `http://localhost:${GRAPHQL_PORT}`
    : IS_PRODUCTION
    ? 'https://telehealth-be.truepill.com'
    : 'https://telehealth-be.falsepill.com')

// We default these to staging but you can override by setting its env var
// Consults Backend (Friday)
export const EMR_BACKEND_ENDPOINT_URL =
  process.env.REACT_APP_EMR_BACKEND_ENDPOINT_URL ||
  (IS_PRODUCTION
    ? 'https://consults.truepill.com'
    : 'https://consults.falsepill.com')

export const KEY_SELECTED_ROLE = 'KEY_SELECTED_ROLE'

export const DEFAULT_COUNTRY = 'US'

export const DEFAULT_TIMEZONE = 'America/Chicago'
